import styled, { css } from 'styled-components';

export const Angle = styled.span<{ open: boolean }>`
  transition: transform 0.2s ease;
  display: inline-block;
  ${(p) =>
    p.open
      ? css`
          transform: rotate(180deg);
        `
      : css`
          transform: rotate(0deg);
        `}
`;
